import { apiClient } from "../lib/api";

export const auditApi = {
  list: (params) => apiClient.get("/audit", { params }),
  get: (eventId) => apiClient.get(`/audit/${eventId}`),
  modules: () => apiClient.get("/audit/modules"),
};
